import React from 'react';
/**
 * BarChartRenderer — Interactive bar chart with selection.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s67.
 * Optimized: extracted shared data normalization + selection hook (~210r → ~110r).
 */

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Cell } from 'recharts';
import { QuestionRendererProps } from './types';
import { normalizeChartData, ChartDataPoint } from './chartDataUtils';
import { useChartSelection } from './useChartSelection';
export function BarChartRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const config = question.data || {};
  const data = normalizeChartData(config);
  const xAxisLabel = config.xAxisLabel || '';
  const yAxisLabel = config.yAxisLabel || '';
  const barColor = config.barColor || '#6366f1';
  const activeBarColor = config.activeBarColor || '#4f46e5';
  const {
    selectedIndex,
    handleItemClick,
    handleKeyDown
  } = useChartSelection({
    questionId: question.id,
    itemCount: data.length,
    idPrefix: 'bar-option',
    onAnswer,
    onReadyChange,
    shouldValidate
  });
  return <div className="w-full max-w-3xl mx-auto flex flex-col items-center" data-id="element-7314">
      <div className="w-full h-[240px] md:h-[340px] bg-white rounded-xl border border-slate-200 shadow-sm p-3 md:p-4" aria-hidden="true" data-id="element-7315">
        <ResponsiveContainer width="100%" height="100%" data-id="element-7316">
          <BarChart data={data} margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 40
        }} data-id="element-7317">
            <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-7318" />
            <XAxis dataKey="label" interval={0} tick={{
            fill: '#64748b',
            fontSize: 12
          }} tickLine={false} axisLine={{
            stroke: '#cbd5e1'
          }} label={xAxisLabel ? {
            value: xAxisLabel,
            position: 'insideBottom',
            offset: -20,
            fill: '#475569',
            fontSize: 13,
            fontWeight: 600
          } : undefined} data-id="element-7319" />
            <YAxis tick={{
            fill: '#64748b',
            fontSize: 12
          }} tickLine={false} axisLine={false} label={yAxisLabel ? {
            value: yAxisLabel,
            angle: -90,
            position: 'insideLeft',
            fill: '#475569',
            fontSize: 14,
            fontWeight: 600
          } : undefined} data-id="element-7320" />
            <Bar dataKey="value" onClick={handleItemClick} cursor="pointer" radius={[4, 4, 0, 0]} data-id="element-7321">
              {data.map((_: ChartDataPoint, index: number) => <Cell key={`cell-${index}`} fill={selectedIndex === index ? activeBarColor : barColor} stroke={selectedIndex === index ? '#312e81' : 'none'} strokeWidth={2} data-id="element-7322" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div role="listbox" aria-label="Kies een staaf" className="flex flex-wrap justify-center gap-2 mt-4" data-id="element-7323">
        {data.map((entry: ChartDataPoint, index: number) => <button key={`option-${index}`} id={`bar-option-${index}`} role="option" aria-selected={selectedIndex === index} tabIndex={0} onClick={() => handleItemClick(null, index)} onKeyDown={e => handleKeyDown(e, index)} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${selectedIndex === index ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`} data-id="element-7324">
            {entry.label}
          </button>)}
      </div>

      <p className="text-center text-slate-500 text-sm mt-4" data-id="element-7325">
        Klik op een staaf of gebruik de pijltjestoetsen
      </p>
    </div>;
}